import { render } from "./FullScreenOverlayDesktop.vue?vue&type=template&id=24e6a058&scoped=true"
import script from "./FullScreenOverlayDesktop.vue?vue&type=script&lang=js"
export * from "./FullScreenOverlayDesktop.vue?vue&type=script&lang=js"

import "./FullScreenOverlayDesktop.vue?vue&type=style&index=0&id=24e6a058&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24e6a058"]])

export default __exports__